'use client'

import { useModalStore } from '@/stores/modal-store'
import { useEffect } from 'react'
import { AuthDialog } from './auth'
import { InviteCodeModal } from './auth/invite-code-modal'
import { BridgeModal } from './bridge/BridgeModal'
import { CommandPalette } from './command-palette'
import {
	DepositPrimaryModal,
	ManualTransferModal,
	MoonPayDepositModal,
} from './deposit-funds-primary'
import { ComingSoonModal } from './shared/coming-soon-modal'
import { GeoDisclaimerModal } from './shared/geo-disclaimer-modal'
import { SupportModal } from './shared/support-modal'
import { TransferModal } from './transfer/TransferModal'
import { WithdrawModal } from './withdraw/WithdrawModal'

export function GlobalModals() {
	const { activeModal, transferPromptData, closeModal, openModal } = useModalStore()

	// Global Cmd+K listener
	useEffect(() => {
		function handleKeyDown(e: KeyboardEvent) {
			if ((e.metaKey || e.ctrlKey) && e.key === 'k') {
				e.preventDefault()
				if (activeModal === 'command-palette') {
					closeModal()
				} else {
					openModal('command-palette')
				}
			}
		}

		document.addEventListener('keydown', handleKeyDown)
		return () => document.removeEventListener('keydown', handleKeyDown)
	}, [activeModal, closeModal, openModal])

	return (
		<>
			<GeoDisclaimerModal />
			<DepositPrimaryModal />
			<ManualTransferModal />
			<MoonPayDepositModal />
			<WithdrawModal />
			<BridgeModal />
			<ComingSoonModal />
			<SupportModal />
			<TransferModal
				isOpen={activeModal === 'transfer-prompt'}
				onClose={closeModal}
				mode="trade-prompt"
				requiredAmount={transferPromptData?.requiredAmount}
				targetPlatform={transferPromptData?.targetPlatform}
				onSuccess={transferPromptData?.onSuccess}
			/>
			<CommandPalette isOpen={activeModal === 'command-palette'} onClose={closeModal} />
			<AuthDialog open={activeModal === 'auth'} onOpenChange={open => !open && closeModal()} />
			{/* InviteCodeModal is rendered by useRegisterUser hook */}
			<InviteCodeModal />
		</>
	)
}
